import Bookmark from './Bookmark';
import './Bookmark.css';
import TaggedBookmarkListName from './TaggedBookmarkListName';
import UserTagPrivateBookmarkCount from './UserTagPrivateBookmarkCount';
import { PropTypes } from 'prop-types';
import Constant from '@/common/constant/Constant';
import { Box, IconButton, Menu } from '@material-ui/core';
import { useState } from 'react';
import { I18n } from 'aws-amplify';
import Utils from '@/common/utils/utils';

TicketBookmark.propTypes = {
    isViewDelete: PropTypes.bool,
    ticketKnowledge: PropTypes.any,
    panelType: PropTypes.any,
    displayMode: PropTypes.any,
    setDisplayMode: PropTypes.any,
    onClickDeleteTicket: PropTypes.any,
    onClickDuplicate: PropTypes.any,
    setIsShowDialogDeleteTicket: PropTypes.any,
    isDisplayDuplicate: PropTypes.any,
};

export default function TicketBookmark(props) {
    const {
        isViewDelete,
        ticketKnowledge,
        panelType,
        displayMode,
        setDisplayMode,
        onClickDeleteTicket,
        onClickDuplicate,
        setIsShowDialogDeleteTicket,
        isDisplayDuplicate
    } = props;

    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleClick = event => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const onClickChangeToEditMode = () => {
        setDisplayMode(Constant.DISPLAY_MODE.EDIT);
    };

    const isDisplayIconEdit = () => {
        if (
            ticketKnowledge?.deletedAt ||
            ticketKnowledge.liveOrArchived === Constant.LIVE_OR_ARCHIVED.ARCHIVED
        ) {
            return false;
        }

        return displayMode === Constant.DISPLAY_MODE.VIEW;
    };
    
    const isShowIconPermanentDelete = () => {
        return !Utils.isEmptyString(ticketKnowledge?.deletedAt);
    };

    return (
        <div className="ticket-knowledge-bookmark">
            <div style={{ paddingRight: 6 }}>
                <Bookmark
                    isViewDelete={isViewDelete}
                    ticketKnowledge={ticketKnowledge}
                    panelType={panelType}
                    isShowEdit={false}
                    isShowDefaultBookmark={true}
                    tagDefaultBookmarkClassName={'reset-position-list-bookmark-icon'}
                />
            </div>
            <Bookmark
                isViewDelete={isViewDelete}
                ticketKnowledge={ticketKnowledge}
                panelType={panelType}
                isShowEdit={true}
                bookmarkPopupContainerClassName={'reset-position-bookmark-popup-container'}
            />

            <div className="ticket-knowledge-bm-tagged-list-text-wrap">
                <TaggedBookmarkListName
                    bookmarkListText={ticketKnowledge?.bookmarkListText}
                    className="ticket-knowledge-bm-tagged-list-text"
                />
                <div className="ticket-knowledge-bm-tagged-list-right-group">
                    {isDisplayIconEdit() && (
                        <IconButton className="itemNav" onClick={() => onClickChangeToEditMode()}>
                            <img src="/assets/image/icon-edit-mode.svg" alt="Edit mode" />
                        </IconButton>
                    )}
                    <UserTagPrivateBookmarkCount ticketKnowledge={ticketKnowledge} />

                    <IconButton
                        className="close"
                        aria-label="more"
                        id="long-button-hamburger"
                        aria-controls={open ?? 'long-menu'}
                        aria-expanded={open ?? 'true'}
                        aria-haspopup="true"
                        onClick={handleClick}
                    >
                        <img src="/assets/image/icon-hamburger.svg" alt="Icon hamburger" />
                    </IconButton>
                    <Menu
                        id="long-menu-hamburger"
                        className="view-mode-group-btn mt-2"
                        anchorEl={anchorEl}
                        open={open}
                        onClose={handleClose}
                        getContentAnchorEl={null}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'right'
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'right'
                        }}
                        MenuListProps={{
                            className: 'view-mode-group-btn-hamburger'
                        }}
                        PaperProps={{
                            style: {
                                minWidth: '160px',
                                minHeight: '40px'
                            }
                        }}
                    >
                        <div className="hamburger-list">
                            {/* Duplicate */}
                            {isDisplayDuplicate && (
                                <Box
                                    className="hamburger-item"
                                    onClick={() => {
                                        onClickDuplicate();
                                        handleClose();
                                    }}
                                >
                                    <IconButton className="itemNav">
                                        <img src="/assets/image/icon-copy.svg" alt="" />
                                    </IconButton>
                                    {I18n.get('HAMBURGER-DUPLICATE')}
                                </Box>
                            )}

                            {/* Soft delete */}
                            {!isShowIconPermanentDelete() && (
                                <Box
                                    className="hamburger-item"
                                    onClick={() => {
                                        onClickDeleteTicket();
                                        handleClose();
                                    }}
                                >
                                    <IconButton className="itemNav">
                                        <img src="/assets/image/icon-tabs-delete.svg" alt="" />
                                    </IconButton>
                                    {I18n.get('HAMBURGER-DELETE')}
                                </Box>
                            )}

                            {/* Permanent delete */}
                            {isShowIconPermanentDelete() && (
                                <Box
                                    className="hamburger-item"
                                    onClick={() => {
                                        setIsShowDialogDeleteTicket(true);
                                        handleClose();
                                    }}
                                >
                                    <IconButton className="itemNav">
                                        <img src="/assets/image/icon-tabs-delete.svg" alt="" />
                                    </IconButton>
                                    {I18n.get('HAMBURGER-PERMANENT-DELETE')}
                                </Box>
                            )}
                        </div>
                    </Menu>
                </div>
            </div>
        </div>
    );
}
